import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'md-icon-button',
  templateUrl: './md-icon-button.component.html',
  styleUrls: ['./md-icon-button.component.css']
})
export class MdIconButtonComponent implements OnInit {
  @Input() public matTooltip: string;
  constructor() { }

  ngOnInit(): void {
  }

}
